import POptionGroup from '../p-select/src/option-group.vue';

/* istanbul ignore next */
POptionGroup.install = function(Vue) {
  Vue.component(POptionGroup.name, POptionGroup);
};

export default POptionGroup;
